import styled from '@emotion/styled'
import ssCss from '@styled-system/css'
import shouldForwardProp from '@styled-system/should-forward-prop'
import { HTMLAttributes } from 'react'
import {
  border,
  BorderProps,
  color,
  ColorProps,
  flexbox,
  FlexboxProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system'

type BaseBoxProps = HTMLAttributes<HTMLDivElement> &
  SpaceProps &
  FlexboxProps &
  ColorProps &
  TypographyProps &
  LayoutProps &
  PositionProps &
  BorderProps

export interface BoxProps extends BaseBoxProps {
  customCss?: any
  as?: any
  ref?: any
  src?: any
  alt?: any
  href?: any
  target?: any
  rel?: any
  autoPlay?: any
  muted?: any
  loop?: any
  key?: any
  controls?: any
  playsInline?: any
  xWebkitAirplay?: any
  x5VideoPlayerFullscreen?: any
  preload?: any
  x5Playsinline?: any
  webkitPlaysinline?: any
}

const Box = styled('div', { shouldForwardProp })<BoxProps>`
  box-sizing: border-box;
  margin: 0;
  ${typography}
  ${flexbox}
  ${space}
  ${color}
  ${layout}
  ${position}
  ${border}
  ${({ customCss }) => ssCss(customCss)}
`

export default Box
